import React from "react";
import { UserIcon } from "../../../assets/svg/AllSvg";
import { Logo } from "../../../assets";

const Step = ({ step }) => {
  return (
    <div className="flex items-center space-x-3">
      {step?.logo ? (
        <div className="sm:max-w-6 sm:min-w-6 min-w-4 sm:h-6 max-w-4 w-full h-4 p-1 rounded-full flex justify-center items-center bg-theme">
          <img src={Logo} alt="logo" className="w-full h-full object-cover" />
        </div>
      ) : (
        <div className="sm:max-w-6 sm:min-w-6 min-w-4 sm:h-6 max-w-4 w-full h-4 rounded-full flex justify-center items-center bg-theme">
          <UserIcon />
        </div>
      )}

      <div className="sm:text-sm text-xs whitespace-nowrap">
        <p className="sm:font-semibold font-bold">{step?.text}</p>
        <p className="">{step?.subText}</p>
      </div>
    </div>
  );
};

export default Step;
